import React from "react";
import PropTypes from "prop-types";
import { Link, graphql } from "gatsby";
import Helmet from "react-helmet";
import moment from "moment";

import { Ad } from "../components/Ad";
import Bio from "../components/bio";
import Layout from "../components/layout";
import SEO from "../components/seo";

const whatIsOld = 4; // 4ish years

const BlogPostTemplate = ({
  data: { markdownRemark, site },
  pageContext: { previous, next },
  location,
}) => {
  const post = markdownRemark;
  const siteTitle = site.siteMetadata.title;

  const showAd = post.frontmatter.advert;
  const now = moment(new Date());
  const postDate = moment(post.frontmatter.date);
  const duration = moment.duration(now.diff(postDate));

  const oldPost = duration.asYears() > whatIsOld;

  return (
    <Layout location={location} title={siteTitle}>
      <SEO
        location={location}
        title={post.frontmatter.title}
        description={post.frontmatter.description || post.excerpt}
      />

      {showAd ? (
        <Helmet>
          <script
            async
            src="//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"
          />
        </Helmet>
      ) : null}

      <header className="blog__title blog--javascript">
        <div className="grid">
          <h1>{post.frontmatter.title}</h1>
        </div>
      </header>

      <aside className="blog__meta grid">
        <div className="meta__wrapper">
          {post.frontmatter.date} in&nbsp;
          <Link
            to={`/blether/cat/${post.frontmatter.category.toLowerCase()} `}
            title={post.frontmatter.category}
          >
            {post.frontmatter.category}
          </Link>
        </div>
      </aside>

      {oldPost ? (
        <div className="blog__old-post">
          <span className="blog__old-post__content">{`Note: this post is ${Math.floor(
            duration.asYears()
          )} years old - code examples may need to be updated!`}</span>
        </div>
      ) : null}
      <article className="blog__article grid main" role="main">
        {showAd ? <Ad /> : null}
        <div dangerouslySetInnerHTML={{ __html: post.html }} />
      </article>

      <aside className="blog__post__footer main">
        {/* <Bio /> */}

        <ul className="blog__article__nav">
          {previous && (
            <li className="blog__previous">
              <Link to={`/blether${previous.fields.slug}`} rel="prev">
                ← {previous.frontmatter.title}
              </Link>
            </li>
          )}
          {next && (
            <li className="blog__next">
              <Link to={`/blether/${next.fields.slug}`} rel="next">
                {next.frontmatter.title} →
              </Link>
            </li>
          )}
        </ul>

        {/* <a
          href="https://www.runnyblock.com"
          title="Play my runner game here"
          className="grid runner-link"
        >
          <img
            src="/runner-link.png"
            alt="Play Runny Block, a game what I made"
          />
        </a> */}
      </aside>
    </Layout>
  );
};

BlogPostTemplate.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({}).isRequired,
    site: PropTypes.string.isRequired,
  }).isRequired,
  pageContext: PropTypes.shape({
    previous: PropTypes.shape({}),
    next: PropTypes.shape({}),
  }).isRequired,
  location: PropTypes.shape({}).isRequired,
};

export default BlogPostTemplate;

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
        author
      }
    }

    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      html
      frontmatter {
        title
        date(formatString: "DD MMMM YYYY")
        description
        category
        advert
      }
    }
  }
`;
